"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnableStepsSchema = void 0;
const createEnableStepsSchema = (steps) => {
    const schema = {};
    for (let idx = 0; idx < steps.length; idx++) {
        const step = steps[idx];
        schema[step.tag] = true;
        if (step.form && !step.form.isValid()) {
            break;
        }
    }
    return schema;
};
exports.createEnableStepsSchema = createEnableStepsSchema;
//# sourceMappingURL=createEnableStepsSchema.js.map